import { render } from "./Electronics.vue?vue&type=template&id=e760722a&scoped=true"
import script from "./Electronics.vue?vue&type=script&lang=js"
export * from "./Electronics.vue?vue&type=script&lang=js"

import "./Electronics.vue?vue&type=style&index=0&id=e760722a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e760722a"]])

export default __exports__